/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpreasonsloaderror5Inputs */

const en_coinvestments_declinedeal_gpreasonsloaderror5 = /** @type {(inputs: Coinvestments_Declinedeal_Gpreasonsloaderror5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load decline reasons, please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to load decline reasons, please try again." |
*
* @param {Coinvestments_Declinedeal_Gpreasonsloaderror5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpreasonsloaderror5 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpreasonsloaderror5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpreasonsloaderror5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpreasonsloaderror5(inputs)
});
export { coinvestments_declinedeal_gpreasonsloaderror5 as "coInvestments_declineDeal_gpReasonsLoadError" }